module.exports = "<edit-header></edit-header>\n\n<div class=\"edit-unauthorized\">\n    <h3 class=\"edit-header\">Not logged in!</h3>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/unauthorized/unauthorized.component.html
// module id = ./src/app/unauthorized/unauthorized.component.html
// module chunks = main